import React, { createContext, useState, useEffect } from 'react';
import AuthService from '../services/authService';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const initializeUser = async () => {
            const currentUser = AuthService.getCurrentUser();
            if (currentUser) {
                setUser({ 
                    username: currentUser.username || currentUser.email, 
                    organization: currentUser.organization, 
                    isOwner: currentUser.isOwner || false,
                    isCustomer: currentUser.isCustomer || false,
                    email: currentUser.email,
                    token: currentUser.access,
                    expiresAt: currentUser.expires_at
                });
            }
        };

        initializeUser();
    }, []);

    return (
        <UserContext.Provider value={{user, setUser}}>
            {children}
        </UserContext.Provider>
    );
};

export const UserConsumer = UserContext.Consumer;

export default UserContext;